import './Header.css';
import React from 'react';
import { Link } from 'react-router-dom';
function Header(props) {
    return (
        <div className="header">
            <div className="navbar header-nav">
                <nav>
                    <div className="nav-wrapper">
                        <Link to="/" className="brand-logo">
                            <img src="/images/socx-black.png" />
                        </Link>
                        <ul id="nav-mobile" className="right main-nav">
                            <li><label style={{textTransform:"lowercase"}}>{props.user.email}</label></li>
                            <li><Link to="/home" className="main-nav-links hide-on-small-only">Home</Link></li>
                            <li><a href="#" className="main-nav-links hide-on-small-only nav-links" onClick={props.signOut}>Logout</a></li>
                        </ul>
                    </div>
                </nav>
            </div>
            <ul id="slide-out" className="sidenav">
                <li><Link to="/home">Home</Link></li>
                <li><a href="#" onClick={props.signOut}>Logout</a></li>
            </ul>
        </div>
    )
}

export default Header
